module.exports = __webpack_public_path__ + "static/media/xiaozhaochao.0886444c.jpg";